'use strict';

var light$5 = require('./packages/aviary-tokens/dist/fullscript/web/themes/light.cjs');
var dark$4 = require('./packages/aviary-tokens/dist/fullscript/web/themes/dark.cjs');
var light$6 = require('./packages/aviary-tokens/dist/fullscript/native/themes/light.cjs');
var dark$5 = require('./packages/aviary-tokens/dist/fullscript/native/themes/dark.cjs');
var light$7 = require('./packages/aviary-tokens/dist/emerson/web/themes/light.cjs');
var desktop$2 = require('./packages/aviary-tokens/dist/fullscript/web/themes/desktop.cjs');
var mobile$4 = require('./packages/aviary-tokens/dist/fullscript/web/themes/mobile.cjs');
var desktop$3 = require('./packages/aviary-tokens/dist/emerson/web/themes/desktop.cjs');
var mobile$5 = require('./packages/aviary-tokens/dist/emerson/web/themes/mobile.cjs');
var mobile$3 = require('./packages/aviary-tokens/dist/fullscript/native/themes/mobile.cjs');
var light$8 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/light.cjs');
var dark$6 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/dark.cjs');
var light$9 = require('./node_modules/aviary-tokens/dist/tokens/native/themes/light.cjs');
var dark$7 = require('./node_modules/aviary-tokens/dist/tokens/native/themes/dark.cjs');
var emerson$1 = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/emerson.cjs');

var light$1 = light$5.light;
var dark$1 = dark$4.dark;
var light$3 = light$6.light;
var dark$3 = dark$5.dark;
var light$4 = light$7.light;
var desktop = desktop$2.desktop;
var mobile$1 = mobile$4.mobile;
var desktop$1 = desktop$3.desktop;
var mobile$2 = mobile$5.mobile;
var mobile = mobile$3.mobile;
var light = light$8.light;
var dark = dark$6.dark;
var light$2 = light$9.light;
var dark$2 = dark$7.dark;
var emerson = emerson$1.emerson;

const fullscriptWebPrimitives = {
    desktop: desktop,
    mobile: mobile$1
};
const emersonWebPrimitives = {
    desktop: desktop$1,
    mobile: mobile$2
};
const fullscriptWebLight = {
    ...light,
    ds5: {
        ...light$1,
        ...fullscriptWebPrimitives
    }
};
const fullscriptWebDark = {
    ...dark,
    ds5: {
        ...dark$1,
        ...fullscriptWebPrimitives
    }
};
({
    ...light$2,
    ds5: {
        ...light$3,
        ...mobile
    }
});
({
    ...dark$2,
    ds5: {
        ...dark$3,
        ...mobile
    }
});
const emersonWeb = {
    ...emerson,
    ds5: {
        ...light$4,
        ...emersonWebPrimitives
    }
};

var emersonWeb_1 = emersonWeb;
var fullscriptWebDark_1 = fullscriptWebDark;
var fullscriptWebLight_1 = fullscriptWebLight;

exports.emersonWeb = emersonWeb_1;
exports.fullscriptWebDark = fullscriptWebDark_1;
exports.fullscriptWebLight = fullscriptWebLight_1;
//# sourceMappingURL=index.cjs.map
